export default function repeatableResultsFactory(
    repeatableBookingService,
    $q,
    $timeout,
    $rootScope,
    Basket,
    moment,
    Log
) {
    var factory = this;

    factory.clearProgressCounter = function () {
        //reset progressCount (timeout allows last count to display)
        $timeout(function () {
            $rootScope.$broadcast("repeatable-progress-done");
        }, 500);
    };

    /**
     * Get Available Repeatable as a Promise
     * @param  {obj} weekday [description]
     * @param  {obj} booking [description]
     * @return {promise} [description]
     */
    factory.asyncPromiseFunc = function (weekday, booking) {
        var deferred = $q.defer();

        repeatableBookingService.getAvailableRepeatable(weekday, booking).then(
            function (result) {
                $rootScope.$broadcast("repeatable-progress-count-add");

                deferred.resolve(result.data);
            },
            function (reason) {
                deferred.reject(reason);
            }
        );

        return deferred.promise;
    };

    /**
     * Extract each booking in useable form
     * @param  [array] rawApiResult [raw data from api]
     * @param  [array] bookingOrigin [Booking starting point]
     * @param  [array] aRepeatables [angular array - all found repeatable dates used to call api ]
     * @return [array] api result in useable form
     */
    factory.processRawApiResults = function (rawBookings, bookingOrigin) {
        var apiResultCollection = [];

        Log.string("-------PARAMETERS-----------");
        Log.obj("Repeatable: rawBookings", rawBookings);

        Log.obj("Repeatable: bookingOrigin", bookingOrigin);
        Log.string("-------PARAMETERS END -----------");

        rawBookings.forEach((rawBooking) => {
            Log.string(
                "-------rawBooking : date : ",
                rawBooking.SearchDate,
                "highlight"
            );
            Log.obj("Repeatable: rawBooking", rawBooking);

            let lanesAlsoAvailable = [];
            let lanesUnavailable = [];
            let repeatableBooking = {
                date: moment(rawBooking.SearchDate),
                dateDisplay: moment(rawBooking.SearchDate).format("DD.MM.YYYY"),
                weekdayName: moment(rawBooking.SearchDate).format("ddd"), // weekday
            };

            if (!rawBooking.ParentLanes.length) {
                repeatableBooking.isUnavailable = true;
            } else {
                // Parent Lane always returns one result
                const parentLane = rawBooking.ParentLanes[0];

                repeatableBooking.parentLane = parentLane;
                repeatableBooking.isUnavailable = false;
                repeatableBooking.laneBestFit = false;
                repeatableBooking.active = false;

                angular.forEach(parentLane.Lanes, function (lane) {
                    Log.obj("Repeatable: lane", lane);

                    // APi obj -> any prices?
                    if (lane.Prices.length) {
                        // Assumption (always one price)
                        lane.period = lane.Prices[0];

                        Log.obj(
                            "Repeatable: Lane:" + lane.LaneName,
                            " - period available : " + lane.period.Available,
                            "highlight"
                        );

                        // Log.obj(
                        //     "Repeatable: Basket.currentBookings",
                        //     Basket.currentBookings
                        // );
                        if (Basket.currentBookings.length) {
                            angular.forEach(
                                Basket.currentBookings,
                                function (basketBooking) {
                                    if (
                                        basketBooking.Periods[0].UniqueKey ==
                                        lane.period.UniqueKey
                                    ) {
                                        Log.string(
                                            "Repeatable: ",
                                            "Booking is allready in the basket"
                                        );
                                        lane.allreadyExistInBasket = true;
                                        repeatableBooking.isUnavailable = true;
                                    }
                                }
                            );
                        }

                        lane.dateDisplay = moment(
                            lane.period.BookingStart
                        ).format("DD.MM.YYYY");
                        lane.weekdayName = moment(
                            lane.period.BookingStart
                        ).format("ddd"); // weekday
                        lane.timeStartDisplay = moment(
                            lane.period.BookingStart
                        ).format("HH:mm");
                        lane.timeEndDisplay = moment(
                            lane.period.BookingEnd
                        ).format("HH:mm");

                        if (lane.period.Available) {
                            repeatableBooking.isUnavailable = false;

                            // FIRST PRIORTY : Same lane as origin
                            if (lane.period.LaneID == bookingOrigin.LaneID) {
                                repeatableBooking.laneBestFit = lane;
                            } else {
                                lanesAlsoAvailable.push(lane);
                            }
                        } else {
                            Log.obj("Repeatable is unavailable: ", lane);
                            lanesUnavailable.push(lane);
                        }
                    } else {
                        Log.obj(
                            "Repeatable in lane has no periods: ",
                            lane.laneName
                        );

                        // if Lane has NO price
                        // repeatableBooking.isUnavailable = true;
                        // FORGET THE LANE
                        lanesUnavailable.push(lane);
                    }
                });

                // console.log(
                //     "----------------PRIORITY ROUND TWO --- FIGHT!!!! -------------"
                // );
                // console.log(repeatableBooking.laneBestFit);

                // If first Priority has not resolved.
                if (!repeatableBooking.laneBestFit) {
                    if (lanesAlsoAvailable.length) {
                        // console.log("TAKE OTHER BEST FIT");

                        // Take first available to be BEST FIT
                        repeatableBooking.laneBestFit = lanesAlsoAvailable[0];
                    } else {
                        // console.log("NONE IS AVAILABLE");

                        // NO LANES AVAILABLE
                        repeatableBooking.isUnavailable = true;
                    }
                }

                repeatableBooking.lanesAlsoAvailable = lanesAlsoAvailable;
                repeatableBooking.lanesUnavailable = lanesUnavailable;
            }
            Log.obj("Repeatable Final : ", repeatableBooking);
            Log.string(
                "Repeatable laneBestFit : ",
                repeatableBooking.laneBestFit
            );

            // DELIVER THE FINAL LANE RESULT !
            apiResultCollection.push(repeatableBooking);
        });

        return apiResultCollection;
    };

    factory.getHttpRequestCount = function (aRepeatables) {
        //reset HttpRequestCount (or activate from null)
        var HttpRequestCount = 0;

        angular.forEach(aRepeatables, function (weekly) {
            angular.forEach(weekly.futureWeekdaysInRange, function () {
                //Used by progress counter
                HttpRequestCount++;
            });
        });

        //console.log('Number of request to Server : ' + HttpRequestCount);

        return HttpRequestCount;
    };

    return factory;
}
